export const SET_SELECTED_FOR_INTERACTION = "setSelectedForInteraction";
